import React from "react";
import { Typography, Paper, useTheme, useMediaQuery } from "@mui/material";
import {
  ConfirmationNumber as TicketIcon,
  FitnessCenter as FitnessCenterIcon,
} from "@mui/icons-material";
import DataTable from "../DataTable";
import { formatCurrency } from "../../utils/formatters";

const PopularStatistics = ({ dashboardData }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!dashboardData) {
    return (
      <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
        Brak danych do wyświetlenia
      </Typography>
    );
  }

  return (
    <>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
          <TicketIcon sx={{ mr: 1 }} />
          Popularne typy karnetów
        </Typography>
        <DataTable
          size={isMobile ? "small" : "medium"}
          rows={dashboardData.popular_pass_types}
          getRowKey={(row, index) => index}
          columns={[
            {
              key: "name",
              label: "Typ karnetu",
              render: (row) => (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{row.pass_type_name}</Typography>
              ),
            },
            {
              key: "count",
              label: "Liczba sprzedanych",
              align: "right",
              render: (row) => <Typography variant="body2">{row.count}</Typography>,
            },
            {
              key: "revenue",
              label: "Przychód",
              align: "right",
              render: (row) => (
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#4facfe' }}>
                  {formatCurrency(row.revenue)}
                </Typography>
              ),
            },
            {
              key: "avg",
              label: "Średnia cena",
              align: "right",
              render: (row) => <Typography variant="body2">{formatCurrency(row.revenue / row.count)}</Typography>,
            },
          ]}
        />
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
          <FitnessCenterIcon sx={{ mr: 1 }} />
          Popularne zajęcia
        </Typography>
        <DataTable
          size={isMobile ? "small" : "medium"}
          rows={dashboardData.popular_lesson_types}
          getRowKey={(row, index) => index}
          columns={[
            {
              key: "name",
              label: "Typ zajęć",
              render: (row) => (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{row.lesson_type_name}</Typography>
              ),
            },
            {
              key: "count",
              label: "Liczba uczestników",
              align: "right",
              render: (row) => (
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#f093fb' }}>{row.count}</Typography>
              ),
            },
          ]}
        />
      </Paper>
    </>
  );
};

export default PopularStatistics;
